import React from 'react';
import { Box, Button, Icon, TableState } from 'web-library';
import { useTranslation } from 'react-i18next';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import { useHistory } from 'react-router-dom';
import { ApplicationStatus } from '../../../api/candidate/exam/model';
import { usePostTransactionLog } from '../../../api-refactored/candidate/usePostTransactionLog';
import { useWOGAA } from '../../../hooks/wogaa';
import RouteKey from '../../../routes/key';

const { amendment } = RouteKey.child;
const {
  coordinatorExamRegistrations,
  coordinatorEditRegistration,
  coordinatorViewDetails,
} = RouteKey.amendment.child;

const AmendmentRequestActionButtons = ({
  classes,
  theme,
  tableState,
  handleOpenDeleteModal,
  dataIndex,
}: {
  classes: any;
  theme: any;
  tableState: TableState;
  handleOpenDeleteModal: (uuid: string) => void;
  dataIndex: any;
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  const logging = usePostTransactionLog({
    onSuccess: () => {
      history.push(
        `/${amendment}/${coordinatorExamRegistrations.route}/${coordinatorEditRegistration.route}/${tableState.data[dataIndex].uuid}`
      );
    },
  });
 // wogaa tracking for coordinator start amendment exam registration //
  const { transactionStart } = useWOGAA('myexamsseab-6455');

  return (
    <Box className={classes.buttonContainer}>
      {(tableState.data[dataIndex].status === ApplicationStatus.REGISTERED ||
        tableState.data[dataIndex].status === ApplicationStatus.PENDING_PAYMENT) && (
        <Button
          id={`button-amendment-view-${dataIndex}`}
          className={classes.button}
          onClick={() => {
            history.push(
              `/${amendment}/${coordinatorExamRegistrations.route}/${coordinatorViewDetails.route}/${tableState.data[dataIndex].uuid}`
            );
          }}
          variant="text"
          color="primary"
          size="small"
        >
          {t('amendment->>AmendmentRequestListing.ViewApplication')}
        </Button>
      )}
      {tableState.data[dataIndex].status === ApplicationStatus.DRAFT && (
        <Button
          id={`button-amendment-continue-${dataIndex}`}
          className={classes.button}
          onClick={() => {
            transactionStart();
            logging.mutate({
              auditActionType: 'CONTINUE_SUBJECT_AMENDMENT',
              applicationId: `${tableState.data[dataIndex].applicationId}`,
            });
          }}
          variant="text"
          color="primary"
          size="small"
          disabled={!tableState.data[dataIndex].windowOpened}
        >
          {t('amendment->>AmendmentRequestListing.ContinueApplication')}
        </Button>
      )}
      {tableState.data[dataIndex].status === ApplicationStatus.DRAFT && (
        <Button
          id={`button-amendment-delete-${dataIndex}`}
          variant="text"
          size="small"
          className={`${classes.button} ${classes.buttonRemove}`}
          onClick={() => handleOpenDeleteModal(tableState.data[dataIndex].uuid)}
        >
          <Icon
            size="M"
            className={classes.iconRemove}
            name={IconName.trash}
            color={theme.color.icon.iconTrash}
          />
          {t('accessArrangement->>AccessArrangements.Delete')}
        </Button>
      )}
    </Box>
  );
};
export default AmendmentRequestActionButtons;
